import {saveAs} from "file-saver";
import {SavedFile} from "../API";

export const makeFullPublicUrlFromId = (id: number) =>
    `${window.location.origin}/api/SavedFile/PreviewPublic?id=${id}`;

export const makeFullUrlFromId = (id: number) =>
    `${window.location.origin}/api/SavedFile/Preview?id=${id}`;

export const makeFullTMnFileId = (id: number) =>
    `${window.location.origin}/api/TMnFiles/File?anQid=${id}${
        localStorage.getItem("auth_token")
            ? `&access_token=${encodeURIComponent(
                localStorage.getItem("auth_token")!,
            )}`
            : ""
    }`;

export const makeFullPublicUrl = (file: SavedFile) =>
    `${window.location.origin}/api${file.serverPath.replace("Preview", "PreviewPublic")}`;

const makeLink = (file: SavedFile) =>
    `/api${file.serverPath}&access_token=${localStorage.getItem("auth_token")}`;

export const makeUrl = (url: string) =>
    `/api/${url}&access_token=${localStorage.getItem("auth_token")}`;

export const DownloadHelper = (file: SavedFile) => {
    const dlink = makeLink(file);
    console.log(dlink);
    saveAs(dlink, file.name);
};

export const OpenInNewTabHelper = (file: SavedFile) => {
    const dlink = makeLink(file);
    console.log(dlink);
    window.open(dlink, "_blank");
};

export const DownloadArbitrary = (url: string, fileName: string = "file") => {
    const dlink = makeUrl(url);
    console.log(dlink);
    saveAs(dlink, fileName);
};

export const OpenInNewTabArbitrary = (
    url: string,
    fileName: string = "file",
): void => {
    const dlink = makeUrl(url);
    console.log(dlink);
    window.open(dlink, "_blank");
};

export const OpenInNewTabArbitraryByHref = (
    url: string,
    fileName: string = "file",
): void => {
    const dlink = makeUrl(url);
    console.log(dlink);
    const a = document.createElement("a");
    a.href = dlink;
    a.download = fileName;
    a.target = "_blank";
    a.click();
};

export const downloadBlob = (blob: Blob, filename: string) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
        setTimeout(() => {
            URL.revokeObjectURL(url);
            window.removeEventListener("click", clickHandler);
        });
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
};

export const DownloadAsBlob = async (
    url: string,
    fileName: string = "file",
): Promise<void> => {
    const finalUrl = makeUrl(url);
    console.log(finalUrl);
    const response = await fetch(finalUrl);
    const blob = await response.blob();
    downloadBlob(blob, fileName);
};
